<template>
  <div class="container">

    <MemberPasswordUpdate
      ref="passwordModal"
      :isProfilePage="true"
      :member_id="null"
    />

    <CollapsibleListItem icon="mdi-account-details" :title="$t('MEMBER.DETAILS')" :expanded="true">
      <div v-if="company.profile">

        <m-row class="mt-4">
          <m-col sm="12" md="4" v-if="company.profile.na">
            <memlist-text-input 
              :title="$t('MEMBER.FIRSTNAME')" 
              v-model="local_member.firstname" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.na">
            <memlist-text-input 
              :title="$t('MEMBER.LASTNAME')" 
              v-model="local_member.lastname" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.pn">
            <memlist-text-input 
              :title="$t('MEMBER.PERSONNR')" 
              v-model="local_member.personnr" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.dob">
            <memlist-text-input 
              :title="$t('MEMBER.DOB')" 
              v-model="local_member.dob" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>

          <m-col sm="12" md="4">
            <memlist-text-input 
              :title="$t('MEMBER.PUBLIC_ID')" 
              v-model="local_member.public_id" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
              :disabled="true"
            />
          </m-col>

          <m-col sm="12" md="4" v-if="company.profile.title">
            <memlist-text-input 
              :title="$t('MEMBER.TITLE')" 
              v-model="local_member.title" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
              :disabled="true"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.avd">
            <memlist-text-input 
              :title="$t('MEMBER.AVD')" 
              v-model="local_member.avd" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.cname">
            <memlist-text-input 
              :title="$t('MEMBER.CNAME')" 
              v-model="local_member.cname" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.org_number">
            <memlist-text-input 
              :title="$t('MEMBER.ORG_NUMBER')" 
              v-model="local_member.org_number" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
            />
          </m-col>

          <m-col sm="12" md="4" v-if="company.profile.student_id">
            <memlist-text-input 
              :title="$t('MEMBER.STUDENT_ID')" 
              v-model="local_member.student_id" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
              :disabled="true"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.public_sex">
            <memlist-select-input2 
              :title="$t('MEMBER.PUBLIC_SEX')" 
              v-model="local_member.public_sex" 
              @input="change_save_data"
              layout="vertical"
              size="sm"
              :items="gender_options"
            />
          </m-col>

          <m-col sm="12" md="4">
            <memlist-text-input 
              :title="$t('MEMBER.PASSWORD')" 
              @input="open_password_modal"
              layout="vertical"
              size="sm"
            >
              <memlist-button variant="outline-success">{{$t('ACCOUNT.UPDATE_PASSWORD')}}</memlist-button>
            </memlist-text-input>
          </m-col>
        </m-row>

        <RightSaveButton
          ref="save-button"
          :text="$t('COMMON.SAVE')"
          @clicked="save_button_clicked()"
        />

      </div>
    </CollapsibleListItem>

  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import MemberPasswordUpdate from '@/view/components/member_editor_v2/MemberPasswordUpdate.vue';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberProfileDetailsComponent',

  props: ['member','company','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    MemberPasswordUpdate,
    RightSaveButton,
    CollapsibleListItem
  },

  watch: {

    member: {
      deep: true,
      handler(val) {
        this.local_member = { ...this.member }
      }
    },

  },

  computed: {

  },

  methods: {
    change_save_data() {
      // when data field has changed and focus lost
    },
    save_button_clicked() {
      setTimeout(()=>{
        this.$refs['save-button'].stop();
      },500);

      this.save_data();
    },

    open_password_modal() {
      this.$refs['passwordModal'].show();
    },

    async save_data() {
      this.$emit('save_data', this.local_member);
    }

  },

  mounted() {

    this.local_member = { ...this.member };

    this.show_form = this.expanded;
  },

  data() {
    return {

      local_member: {},

      show_form: true,

      gender_options: [
        { text: this.$t('COMMON.MAN'), value: 'M' },
        { text: this.$t('COMMON.WOMAN'), value: 'F' },
        { text: this.$t('COMMON.OTHER'), value: 'O' },
        { text: this.$t('COMMON.UNKNOWN'), value: 'U' },
      ],

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
